import Typography from "@mui/material/Typography";
import React from "react";
import { COLOR_GREY_12 } from "shared/theme/colors";
import { StyledEmptyContainer } from "./styled";

const Empty = () => {
  return (
    <StyledEmptyContainer>
      <Typography variant="bodySMedium" color={COLOR_GREY_12}>
        Select a chat to start answering
      </Typography>
    </StyledEmptyContainer>
  );
};

export default Empty;
